
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";

const DesktopNavigation = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  
  // Consider both "/" and "/roadmap" as roadmap for highlighting
  const isRoadmapActive = currentPath === "/" || currentPath === "/roadmap";
  
  return (
    <nav className="hidden md:flex items-center gap-2 mx-auto">
      <Button 
        variant="ghost" 
        size="sm" 
        className={currentPath === "/parts" ? "font-medium selected-theme" : "text-muted-foreground"} 
        asChild
      >
        <Link to="/parts">Parts</Link>
      </Button>
      <Button 
        variant="ghost" 
        size="sm" 
        className={currentPath === "/tutorials" ? "font-medium selected-theme" : "text-muted-foreground"} 
        asChild
      >
        <Link to="/tutorials">Tutorials</Link>
      </Button>
      <Button 
        variant="ghost" 
        size="sm" 
        className={currentPath === "/tools" ? "font-medium selected-theme" : "text-muted-foreground"} 
        asChild
      >
        <Link to="/tools">Tools</Link>
      </Button>
      <Button 
        variant="ghost" 
        size="sm" 
        className={isRoadmapActive ? "font-medium selected-theme" : "text-muted-foreground"} 
        asChild
      >
        <Link to="/roadmap">Roadmap</Link>
      </Button>
      <Button 
        variant="ghost" 
        size="sm" 
        className={currentPath === "/donate" ? "font-medium selected-theme" : "text-muted-foreground"} 
        asChild
      >
        <Link to="/donate">Donate</Link>
      </Button>
    </nav>
  );
};

export default DesktopNavigation;
